const env = process.env || {}; // eslint-disable-line no-process-env

[
  'NODE_ENV',
  'APP_PORT',
  'API_URL'
].forEach((name) => {
  if (!env[name]) {
    console.log(`Environment variable ${name} is missing, use default instead.`);
  }
});

const config = {
  ENV: env.NODE_ENV || 'development',
  staticURL: 'https://danangtrade.gov.vn/',
  API_URL: 'https://api.danangtrade.gov.vn/api/',
  PORT: Number(env.APP_PORT || 3002),
  UploadImageURL: 'https://img.danangtrade.gov.vn',
};

module.exports = config;



// WEBPACK FOOTER //
// ./constants/config.js